<template>
  <form id="form-checkout" method="post" @submit.prevent="generatePaymentToken">
    <div class="mb-3">

      <div class="card rounded border-0 shadow">
        <div class="bg-light p-4 text-center rounded-top">
          <h4 class="mb-0 card-title text-primary">Cartão de crédito</h4>
        </div>

        <div class="card-body">
          <div class="row">
            <div class="col-md-12">
              <div class="mb-3">
                <label class="form-label" for="form-checkout__cardholderName">Nome: <span
                  class="text-danger">*</span></label>
                <input name="name" id="form-checkout__cardholderName" type="text"
                       class="form-control fw-bold" required="" v-model="holderName"
                       placeholder="Ex. João A Farias">
              </div>
            </div>
            <div class="col-md-12">
              <div class="mb-3">
                <label class="form-label" for="form-checkout__cardholderCpf">CPF do titular do cartão: <span
                  class="text-danger">*</span></label>
                <input id="form-checkout__cardholderCpf" type="text" inputmode="numeric"
                       class="form-control fw-bold" required v-model="cardholderCpf"
                       placeholder="000.000.000-00" maxlength="14" v-mask="'###.###.###-##'">
                <small class="text-danger" v-if="cpfError">{{ cpfError }}</small>
              </div>
            </div>
            <div class="col-md-12">
              <div class="mb-3">
                <label class="form-label" for="credit_card_number">
                  Número do cartão: <span class="text-danger">*</span>
                </label>
                <input type="text" autocomplete="off" id="form-checkout__cardNumber"
                       class="form-control fw-bold" v-mask="'#### #### #### ####'" v-model="number"
                       required="" placeholder="0000 0000 0000 0000">
              </div>
            </div>
            <div class="col-md-6">
              <div class="mb-3">
                <label class="form-label" for="credit_card_data_valid">Data de expiração: <span
                  class="text-danger">*</span></label>
                <input type="text" autocomplete="off" id="form-checkout__expirationDate"
                       class="form-control fw-bold" v-model="expirationDate"
                       required="" placeholder="MM/AAAA" v-mask="'##/####'">
              </div>
            </div>
            <div class="col-md-6">
              <div class="mb-3">
                <label class="form-label" for="credit_card_cvv">Código de segurança: <span
                  class="text-danger">*</span></label>
                <input type="text" autocomplete="off" v-model="ccv" id="form-checkout__securityCode"
                       class="form-control fw-bold"
                       required="" placeholder="CVV" v-mask="'###'">
              </div>
            </div>
            <div class="col-md-12" v-if="schedule.availabilityTime.avail_online">
              <br>
              <div class="mb-3">
                <div class="form-check">
                  <label class="form-check-label" for="flexCheckDefault">
                    Ao agendar você concorda com
                    <a target="_blank" href="https://policies.ubbimed.com.br/term-telemedicine.php"
                       class="text-primary">
                      Termos da teleconsulta.
                    </a>
                  </label>
                </div>
              </div>
            </div>
            <div class="col-md-12">
              <slot name="saveCardOptions"></slot>
            </div>
            <div class="col-md-12">
              <div class="d-grid">
                <button class="btn btn-primary" type="submit" id="form-checkout__submit">
                  Agendar consulta
                </button>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </form>
</template>

<script>
import {mask} from "vue-the-mask";
import http from "../../../helpers/http";

export default {
  name: "CreditCardAS",
  directives: {
    mask,
  },
  props: {
    booking: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      msgErrorHashCreditCard: '',
      holderName: '',
      cardholderCpf: '',
      cpfError: '',
      number: '',
      expirationDate: '',
      ccv: '',
      installment: 1,
      ipAddress: 1,
    }
  },
  computed: {
    paymentMethod() {
      return this.schedule.paymentMethod;
    },
    schedule() {
      return this.booking || this.$store.state.toSchedule.schedule;
    },
    userAuth() {
      return this.$store.state.auth.user;
    },
  },
  created() {
    const raw = (this.$store.state.auth.user?.user_cpf || '').replace(/\D/g, '').slice(0, 11)
    if (raw.length === 11) {
      this.cardholderCpf = raw.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')
    }
  },
  mounted() {
    fetch("https://checkip.amazonaws.com")
      .then(res => res.text())
      .then(ip => {
        this.ipAddress = ip;
      });

  },
  methods: {
    async generatePaymentToken() {
      try {
        const holderDocument = (this.cardholderCpf || '').replace(/\D/g, '')
        if (holderDocument.length !== 11) {
          this.cpfError = 'Informe o CPF do titular do cartão.'
          return
        }
        this.cpfError = ''

        let [month, year] = this.expirationDate.split('/');
        this.$emit('onSubmit', {
          credit_card_number: this.number,
          cardholder_name: this.holderName,
          cardholder_identification_number: holderDocument,
          security_code: this.ccv,
          installments: this.installment,
          expiration_month: month,
          expiration_year: year,
          ip_address: this.ipAddress,
        });
      } catch (error) {
        console.log("Código: ", error.code);
        console.log("Nome: ", error.error);
        console.log("Mensagem: ", error.error_description);
      }
    }
  }
}
</script>

<style scoped>

</style>